import React from "react";

export default [
    {
        path: '/signIn',
        exact: true,
        auth: false,
        component: React.lazy(() => import('../components/SignIn'))
    },
    {
        path: '/signUp',
        exact: true,
        auth: false,
        component: React.lazy(() => import('../components/SignUp'))
    },
    {
        path: '/changePassword',
        exact:true,
        auth:false,
        component: React.lazy(() => import('../components/ChangePassword'))
    },
    {
        path: '/resetPassword',
        exact:true,
        auth:false,
        component: React.lazy(()=> import('../components/ResetPassword'))
    },
    {
        path: '/forceChangePassword',
        exact:true,
        auth:false,
        component: React.lazy(()=> import('../components/ForceChangePassword'))
    }
];



// WEBPACK FOOTER //
// ./src/Routes/Auth.js